import {SupportedLocale} from '@multipass-i18n';

import {LegalDocument, Session} from '../../dal';

export class SessionEvents {
    public static readonly loginLinkRequested = 'loginLinkRequested';
    public static readonly signUpRequested = 'signUpRequested';
    public static readonly legalDocumentsRequested = 'legalDocumentsRequested';
    public static readonly legalDocumentsLoaded = 'legalDocumentsLoaded';
    public static readonly deleteAccountRequested = 'deleteAccountRequested';
    public static readonly deleteAccountFailed = 'deleteAccountFailed';
    public static readonly verifyCodeRequested = 'verifyCodeRequested';
    public static readonly loginRestartRequested = 'loginRestartRequested';
    public static readonly loginSuccess = 'loginSuccess';
    public static readonly loginError = 'loginError';
    public static readonly awaitingTermsRequired = 'awaitingTermsRequired';
    public static readonly acceptTermsRequested = 'acceptTermsRequested';
    public static readonly signInExpired = 'signInExpired';
    public static readonly signInRejected = 'signInRejected';
    public static readonly signUpRejected = 'signUpRejected';
    public static readonly signOut = 'signOut';
    public static readonly sessionRestored = 'sessionRestored';
    public static readonly localeChanged = 'localeChanged';
    public static readonly localeRestored = 'localeRestored';
    public static readonly scriptPreferenceChosen = 'scriptPreferenceChosen';
    public static readonly scriptPreferenceUpdated = 'scriptPreferenceUpdated';
    public static readonly scriptPreferenceRejected = 'scriptPreferenceRejected';
}

export interface LoginLinkRequestedEvent {
    readonly email: string;
}

export interface SignUpRequestedEvent {
    readonly email: string;
    readonly displayName: string;
    readonly acceptedDocumentIds: string[];
}

export interface LegalDocumentsLoadedEvent {
    readonly documents: LegalDocument[];
}

export interface DeleteAccountFailedEvent {
    readonly error: string;
    readonly code: string | null;
}

export interface VerifyCodeRequestedEvent {
    readonly code: string;
}

export interface LoginSuccessEvent {
    readonly session: Session;
}

export interface LoginErrorEvent {
    readonly error: string;
    readonly code: string | null;
}

export interface AwaitingTermsRequiredEvent {
    readonly outstandingLegalDocumentIds: string[];
    readonly signInTicket: string;
}

export interface SignInExpiredEvent {
    readonly message: string;
    readonly code: string | null;
}

export interface SignInRejectedEvent {
    readonly message: string;
    readonly code: string;
}

export interface SignUpRejectedEvent {
    readonly message: string;
    readonly code: string;
}

export interface SessionRestoredEvent {
    readonly session: Session;
}

export interface LocaleChangedEvent {
    readonly locale: SupportedLocale;
}

export interface LocaleRestoredEvent {
    readonly locale: SupportedLocale;
}

export interface ScriptPreferenceChosenEvent {
    readonly scriptPreference: string;
}

export interface ScriptPreferenceUpdatedEvent {
    readonly scriptPreference: string | null;
    readonly pendingDecision: string | null;
}

export interface ScriptPreferenceRejectedEvent {
    readonly message: string;
    readonly code: string | null;
}
